import { render, staticRenderFns } from "./AssociationFileCard.vue?vue&type=template&id=43843960&scoped=true"
import script from "./AssociationFileCard.vue?vue&type=script&lang=js"
export * from "./AssociationFileCard.vue?vue&type=script&lang=js"
import style0 from "./AssociationFileCard.vue?vue&type=style&index=0&id=43843960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43843960",
  null
  
)

export default component.exports